import { useMemo } from 'react'
import { LocalStorageService } from '../services'

const useUserRole = () => {
  const localStorageService = new LocalStorageService()

  const userRole = useMemo(() => {
    try {
      const user = localStorageService.getLocalStorageItem('user')
      
      if (!user || !user.userMetaData || !user.userMetaData.userRoles) {
        return { isAdmin: false, roles: [] }
      }

      const userRoles = user.userMetaData.userRoles
      const isAdmin = !!userRoles.find(userRole => 
        userRole.role.key === process.env.REACT_APP_ROLE_GENERAL_ADMIN
      )

      return { 
        isAdmin, 
        roles: userRoles 
      }
    } catch (error) {
      console.error('Error al obtener rol del usuario:', error)
      return { isAdmin: false, roles: [] }
    }
  }, [])

  return userRole
}

export default useUserRole